<template>
  <div class="party-mass-work-detail-page">
    <button class="detail-back" type="button" @click="goBack">返回</button>
    <header class="detail-top">
      <h1 class="detail-top__title">{{ pageTitle }}</h1>
      <div class="detail-top__meta">
        <span class="detail-top__date">{{ pageDate }}</span>
        <span class="detail-top__subtitle">{{ pageSubtitle }}</span>
      </div>
    </header>

    <section class="detail-section">
      <div class="detail-container">
        <div class="detail-content">
          <template v-for="(block, idx) in contentFlow" :key="idx">
            <h2 v-if="block.type === 'heading'" class="detail-heading">{{ block.text }}</h2>
            <p v-else-if="block.type === 'text'" class="detail-paragraph">{{ block.text }}</p>
            <img v-else-if="block.type === 'image'" class="detail-image" :src="block.src"
              :alt="block.alt || pageTitle" />
          </template>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

const DETAIL_BY_TITLE = {
  '党支部成立 激活基层治理新动能': {
    subtitle: '党建引领促发展 凝心聚力谱新篇',
    date: '2025-08-20',
    flow: [
      {
        type: 'text',
        text: '为深入贯彻落实新时代党的建设总要求，充分发挥党组织在企业中的政治引领和战斗堡垒作用，合肥千手医疗科技有限责任公司积极响应上级党委号召，扎实推进基层党组织建设。2025年8月20日，中共合肥高新区天乐社区服务中心委员会正式批复，同意成立中共合肥千手医疗科技有限责任公司支部委员会。'
      },
      {
        type: 'heading',
        text: '一、组织成立，开启新篇'
      },
      {
        type: 'text',
        text: '2025年8月20日，中共合肥千手医疗科技有限责任公司支部委员会获中共合肥高新区天乐社区服务中心委员会正式批准成立（合高天发〔2025〕52号）。这标志着公司在加强党的建设、推动党建工作与企业融合发展方面迈出了坚实的一步。'
      },
      {
        type: 'image',
        src: require('@/assets/images/PartyMassWork/PartyBranch/PartyBranch3.jpg'),
        alt: '活动纪实'
      },

      {
        type: 'heading',
        text: '二、党员大会，民主选举'
      },
      {
        type: 'text',
        text: '2025年9月16日，公司召开全体党员大会，严格按照《中国共产党章程》和《中国共产党基层组织选举工作条例》有关规定，选举产生第一届党支部书记。大会程序规范、氛围庄重，充分体现了党内民主和党员意志的统一，为支部后续工作的顺利开展奠定了坚实的组织基础。'
      },
      {
        type: 'image',
        src: require('@/assets/images/PartyMassWork/PartyBranch/PartyBranch4.jpg'),
        alt: '活动纪实'
      },
      {
        type: 'heading',
        text: '三、挂牌启航，使命在肩'
      },
      {
        type: 'text',
        text: '2025年9月25日，中共合肥千手医疗科技有限责任公司支部委员会正式挂牌。支部的成立与挂牌，不仅是公司党建工作的重要里程碑，更是企业坚持党建引领、凝聚发展合力的生动实践。'
      },
      {
        type: 'image',
        src: require('@/assets/images/PartyMassWork/PartyBranch/PartyBranch1.jpg'),
        alt: '活动纪实'
      },
      {
        type: 'heading',
        text: '四、展望未来，砥砺前行'
      },
      {
        type: 'text',
        text: '新征程赋予新使命，新起点呼唤新作为。中共合肥千手医疗科技有限责任公司支部委员会将坚持以习近平新时代中国特色社会主义思想为指导，紧紧围绕企业发展实际，充分发挥党组织的战斗堡垒作用和党员的先锋模范作用，推动党建工作与企业经营管理深度融合，为实现公司高质量发展提供坚强的政治保障和组织保障。'
      },
      {
        type: 'image',
        src: require('@/assets/images/PartyMassWork/PartyBranch/PartyBranch2.jpg'),
        alt: '活动纪实'
      }
    ]
  },

  '董事长陈佩红、党支部书记李春发参加高新区“先锋淬炼”示范培训班': {
    subtitle: '共话发展聚合力 党建联动促提升',
    date: '2025-12-17',
    flow: [
      {
        type: 'text',
        text: '为深入学习贯彻党的二十届四中全会精神，进一步提升企业党建工作水平，推动党建工作与业务发展深度融合，2025年12月17日至19日，合肥高新区党建工作部举办“先锋淬炼”系列课（第3期）——高新区新兴领域“强党建、促发展”示范培训班。我司董事长陈佩红、党支部书记李春发全程参加培训，圆满完成学习任务。'
      },
      {
        type: 'heading',
        text: '一.聚焦党建引领 提升履职能力'
      },
      {
        type: 'text',
        text: '本次培训班为期三天，共有来自全区非公企业和社会组织的党组织书记、出资人、省派党建指导员、党务工作者等约84人参加。培训内容涵盖理论辅导、政策解读、实务操作、现场观摩等多个板块，课程设置科学、安排紧凑。'
      },
      {
        type: 'text',
        text: '开班仪式上，高新区党建工作部（组织人事局）副部长程琦作动员讲话，强调要持续加强新兴领域党建工作，推动党建优势转化为发展优势。市委党校党史党建教研部副主任尹洁作《二十届四中全会精神宣讲》专题辅导，帮助学员准确把握当前党建工作的政治方向与政策重点。'
      },
      {
        type: 'image',
        src: require('@/assets/images/PartyMassWork/SymposiumMC/SymposiumMC1.jpg'),
        alt: '座谈会'
      },
      {
        type: 'heading',
        text: '二.实务辅导结合 助力企业发展'
      },
      {
        type: 'text',
        text: '在“三师助企”专题辅导环节，税务、财务领域专家围绕企业税费政策与财务管理规范进行深入讲解，为企业提升合规经营能力提供了专业指导。参训人员还先后走进科大国创软件股份有限公司、维天运通股份有限公司，实地观摩党建工作与经营管理深度融合的实践成果，学习先进经验。'
      },
      {
        type: 'heading',
        text: '三.经验分享赋能 激发党建活力'
      },
      {
        type: 'text',
        text: '市委社会工作部非公经济和社会组织党建处处长曹涛作专题授课，省派优秀党建指导员江阳结合实践经验分享了《“三力齐发”破新题，党建引领开新局》的工作思路。中科大国祯有限公司党支部书记谢贻富、维天运通股份有限公司党委书记王铁军分别围绕党建助力企业数字化转型、党建引领企业发展等主题进行授课，内容丰富、案例生动，为参训学员提供了宝贵借鉴。'
      },
      {
        type: 'image',
        src: require('@/assets/images/PartyMassWork/SymposiumMC/SymposiumMC2.jpg'),
        alt: '座谈会'
      },
      {
        type: 'heading',
        text: '四.学以致用 推动党建与发展深度融合'
      },
      {
        type: 'text',
        text: '我司董事长陈佩红在培训中表示，党建工作是企业健康发展的重要保障，此次培训内容务实、形式多样，既有理论高度，又有实践深度，为企业下一步深化党建工作提供了清晰思路。党支部书记李春发也表示，将以此次培训为契机，进一步强化支部建设，激发党员活力，推动党建工作走深走实。'
      },
      {
        type: 'text',
        text: '此次培训不仅提升了我司参训人员的政治素养和业务能力，也为企业进一步加强新兴领域党建工作提供了新思路、新方法。未来，我司将继续坚持“党建强、发展强”的理念，积极融入高新区党建工作整体布局，不断探索党建引领企业发展的新路径，以高质量党建引领企业高质量发展，为区域经济社会发展贡献更大力量。'
      },

    ]
  },
  '党建惠民送祝福 情暖梦城社区': {
    subtitle: '情暖寒冬送关怀 爱心慰问暖人心',
    date: '2026-02-04',
    flow: [
      {
        type: 'text',
        text: '寒冬虽冷，温情不减。为切实关心关爱困难群体和新业态就业人员，传递社会温暖，筑牢民生底线，梦城社区积极开展“情暖新业态·关爱暖人心”慰问活动，为快递员等新业态就业人员及困难群体送去手套、帽子等保暖物资，用实际行动传递温情，提升群众的幸福感与安全感。'
      },
      {
        type: 'heading',
        text: '一、精准对接，筑牢关爱防线'
      },
      {
        type: 'text',
        text: '社区工作人员提前摸排辖区内困难群体情况及新业态就业人员需求，精准掌握快递员、外卖小哥等户外劳动者的保暖需求，精心筹备了保暖手套、帽子等物资，确保慰问物资能够精准送到需要的人手中。此次活动聚焦群众“急难愁盼”问题，把温暖送到群众最需要的地方，让困难群体和新业态就业人员感受到社区的关怀与社会的温情。'
      },
      {
        type: 'image',
        src: require('@/assets/images/PartyMassWork/DeliveringBlessings/DeliveringBlessings1.jpg'),
        alt: '情暖梦城社区'
      },

      {
        type: 'heading',
        text: '二、物资帮扶，传递冬日暖意'
      },
      {
        type: 'text',
        text: '慰问现场，社区工作人员与快递员及困难群体亲切交谈，详细询问他们的工作状况、生活难处和实际需求，叮嘱快递员户外工作时注意保暖、注意安全，鼓励困难群体树立信心、积极生活。随后，工作人员为大家一一送上保暖手套、帽子等物资，每一份物资都承载着社区的关怀，每一句叮嘱都传递着浓浓的暖意，让大家在寒冬中感受到了实实在在的温暖。'
      },
      {
        type: 'image',
        src: require('@/assets/images/PartyMassWork/DeliveringBlessings/DeliveringBlessings2.jpg'),
        alt: '情暖梦城社区'
      },
      {
        type: 'heading',
        text: '三、温情相伴，共筑和谐社区'
      },
      {
        type: 'text',
        text: '新业态就业人员是城市运转的“摆渡人”，困难群体是社区关怀的重点对象。此次慰问活动，不仅为他们送去了物质上的帮助，更给予了他们精神上的鼓励与慰藉。下一步，梦城社区将持续关注困难群体和新业态就业人员的需求，开展更多形式多样的慰问帮扶活动，用温情与责任搭建起社区与群众之间的“连心桥”，不断提升群众的幸福感、安全感和归属感，共建和谐、温暖、有温度的社区。'
      },
      {
        type: 'image',
        src: require('@/assets/images/PartyMassWork/DeliveringBlessings/DeliveringBlessings5.jpg'),
        alt: '活动情暖梦城社区纪实'
      },
      {
        type: 'image',
        src: require('@/assets/images/PartyMassWork/DeliveringBlessings/DeliveringBlessings3.jpg'),
        alt: '活动情暖梦城社区纪实'
      },
      {
        type: 'image',
        src: require('@/assets/images/PartyMassWork/DeliveringBlessings/DeliveringBlessings4.jpg'),
        alt: '活动情暖梦城社区纪实'
      },

    ]
  },
  '福字传情 党支部践行初心使命': {
    subtitle: '笔墨传情送祝福 党建关怀暖人心',
    date: '2026-02-07',
    flow: [
      {
        type: 'text',
        text: '春寒渐退，暖意渐浓，为进一步传承中华优秀传统文化，传递党支部对全体员工的关怀与问候，营造温馨和谐的团队氛围，我党支部开展“书写福字送春联，情暖职工迎新春”主题活动，以笔墨为媒，将美好祝福送到每一位员工手中。'
      },
      {
        type: 'heading',
        text: '一、以笔为礼，书写新春祈愿'
      },
      {
        type: 'text',
        text: '活动现场，党支部书记李春发挥毫泼墨、笔走龙蛇，一笔一划间，将对员工的美好祝福融入笔墨之中。大红的福字喜庆吉祥，工整的春联寓意深远，“福满人间添喜乐，春盈大地启新程”“凝心聚力跟党走，携手奋进新征程”，每一幅作品都饱含着党支部的深切关怀，承载着对员工新一年平安顺遂、阖家幸福的美好祝愿。'
      },
      {
        type: 'image',
        src: require('@/assets/images/PartyMassWork/SendingBlessingsMC/SendingBlessingsMC2.jpg'),
        alt: '福字传情'
      },

      {
        type: 'heading',
        text: '二、以情传暖，传递组织温情'
      },
      {
        type: 'text',
        text: '书写完成后，党支部成员分组将福字和春联送到每一位员工手中，亲手传递新春的问候。拿到带着墨香的福字和春联，员工们脸上洋溢着幸福的笑容，纷纷表示感受到了党支部大家庭的温暖。此次送福字、送春联活动，不仅为员工送上了新春的祝福，更拉近了党支部与员工之间的距离，增强了团队的凝聚力和向心力，让大家在浓厚的节日氛围中感受到了组织的关怀与温暖。'
      },
      {
        type: 'image',
        src: require('@/assets/images/PartyMassWork/SendingBlessingsMC/SendingBlessingsMC1.png'),
        alt: '福字传情'
      },
      {
        type: 'heading',
        text: '三、初心不改，践行服务使命'
      },
      {
        type: 'text',
        text: '此次活动既是对中华优秀传统文化的传承与弘扬，也是党支部践行“我为群众办实事”的具体体现。未来，党支部将继续立足员工需求，开展更多有温度、有意义的活动，把关怀送到员工心坎上，引导全体员工凝心聚力、奋勇争先，以更饱满的热情投入到工作中，共同书写高质量发展的新篇章。'
      },
      {
        type: 'image',
        src: require('@/assets/images/PartyMassWork/SendingBlessingsMC/SendingBlessingsMC3.png'),
        alt: '福字传情'
      },
    ]
  },
}

const DETAIL_BY_ID = {
  '1': DETAIL_BY_TITLE['党支部成立 激活基层治理新动能'],
  '2': DETAIL_BY_TITLE['党建聚合力 梦城社区座谈会共促发展'],
  '3': DETAIL_BY_TITLE['党建惠民送祝福 情暖梦城社区'],
  '4': DETAIL_BY_TITLE['福字传情 党支部践行初心使命'],
}

export default {
  name: 'PartyMassWorkDetail',
  computed: {
    pageTitle() {
      const title = this.$route?.query?.title
      return typeof title === 'string' && title.trim() ? title.trim() : '党群建设'
    },
    detail() {
      const id = this.$route?.query?.id
      const byId = typeof id === 'string' ? DETAIL_BY_ID[id] : undefined
      if (byId) return byId

      const byTitle = DETAIL_BY_TITLE[this.pageTitle]
      if (byTitle) return byTitle

      return DETAIL_BY_ID['1']
    },
    pageDate() {
      if (this.detail && this.detail.date) return this.detail.date
      return new Date().toISOString().slice(0, 10)
    },
    pageSubtitle() {
      return this.detail ? this.detail.subtitle : ''
    },
    contentFlow() {
      return this.detail ? this.detail.flow : []
    }
  },
  methods: {
    goBack() {
      const hasHistory = typeof window !== 'undefined' && window.history && window.history.length > 1
      if (hasHistory) {
        this.$router.back()
        return
      }
      this.$router.push({ name: 'PartyMassWork' })
    }
  }
}
</script>

<style scoped>
@import url(../../style/PartyMassWork/PartyMassWorkDetail.css);
</style>
